import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonSearchListing, PersonSearchService } from '../_services/person-search.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { SearchtoolboxService } from '../_services/searchtoolbox.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { JobboardsComponent } from '../jobboards/jobboards.component';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, delay } from 'rxjs/operators';
import { SessionStorageService } from "../_services/session-storage.service";
import { ContinentHandlerService } from '../_services/continent-handler.service';
import { JdData } from '../common-interfaces-classes/JdData';
import { JdDataService } from '../jd-data.service';
import { GeneralConstants } from '../constants/GeneralConstants';
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { HashService } from '../_services/hash.service';
import { GenAiJdSearchComponent } from '../gen-ai-jd-search/gen-ai-jd-search.component';
import { TextExtractResponse } from '../common-interfaces-classes/TextEtractResponse';
import { isJSDocThisTag } from 'typescript';
import { TalentpoolService } from '../_services/talentpool.service';
import { Location } from '@angular/common';
import { TransactionService } from '../_services/transaction.service';
import { AggregationService } from '../_services/aggregation.service';


@Component({
    selector: 'app-person-search',
    templateUrl: './person-search.component.html',
    styleUrls: ['./person-search.component.scss'],
    standalone: false
})
export class PersonSearchComponent implements OnInit, OnDestroy {
  reportsAggs: any;
  total: any;
  dataSourceCurrentCompany: any = [];
  dataSourceFunctions: any = [];
  dataSourceWorkCountry: any = [];
  dataSourcePastCompany: any = [];
  dataSourceSkills: any = [];
  dataSourceCurrentJobTitle: any = [];
  dataSourcePastJobTitle: any = [];
  dataSourceGender: any = [];
  dataSourceSeniority: any = [];
  totalCandidatesCount: any = 0;
  isQuickSearch: boolean = true;
  isAdvanceSearch: boolean = false;
  isSimilarCandidate: boolean = false;
  isJdSearch: boolean = false;
  showJDNotAddedError: boolean = false;
  jdParseError: boolean;
  jobtitles: any[] = [];
  mandatoryskills: any[] = [];
  preferredskills: any[] = [];
  locations: any[] = [];
  jdMode: boolean;
  additionfields: Boolean;
  @ViewChild('noCreditsJDParse') noCreditsJDParse: TemplateRef<any>;
  recommendedjobtitle: any[] = []
  recommendedskills: any[] = []
  deselectedJobTitlesArray: any[] = [];
  deselectedSkillsArray: any[] = [];
  filteredJobTitleOptions: Array<any> = [];
  filteredMandatorySkillsOptions: Array<any> = [];
  filteredPreferredSkillsOptions: Array<any> = [];
  filteredLocationsOptions: Array<any> = [];
  filteredCompaniesOptions: Array<any> = [];
  filteredIndustriesOptions: Array<any> = [];
  getResultForLinkedin: any[] = [];
  searchResults: any[] = [];
  platformselected: any = 'LinkedIn'
  fieldsRequired: boolean;
  startindex: number = 100;
  isCurrentJobTitle: Boolean = false;
  isCurrentCompany: Boolean = false;
  isOpentoWork: Boolean = false;
  companies: any[] = [];
  excludekeywords: any[] = [];
  synonyms: any[] = []
  boolean_synonyms: any[] = []
  categorySelected: any = 'All';
  industries: any[] = [];
  minExperience: any;
  maxExperience: any;
  pdlPaginationKey: any;
  platformlist: any = [{
    platforname: 'General',
  }, {
    apiname: 'linkedInSearch',
    platforname: 'LinkedIn',
    classname: 'fab mr-1 fa-linkedin-square'
  }, {
    apiname: 'twitterSearch',
    platforname: 'Twitter',
    classname: 'fa-brands mr-1 fa-square-x-twitter'
  }, {
    apiname: 'xingSearch',
    platforname: 'Xing',
    classname: 'fab mr-1 fa-xing'
  }, {
    platforname: 'Technical',
  }, {
    apiname: 'githubSearch',
    platforname: 'GitHub',
    classname: 'fab mr-1 fa-github'
  }, {
    apiname: 'stackOverflowSearch',
    platforname: 'Stack Overflow',
    classname: 'fab mr-1 fa-stack-overflow'
  }, {
    apiname: 'kaggleSearch',
    platforname: 'Kaggle',
    classname: 'fab mr-1 fa-kaggle'
  }, {
    platforname: 'Creative',
  }, {
    apiname: 'behanceSearch',
    platforname: 'Behance',
    classname: 'fab mr-1 fa-behance'
  }, {
    apiname: 'dribbbleSearch',
    platforname: 'Dribbble',
    classname: 'fab mr-1 fa-dribbble'
  }, {
    apiname: 'pdlPersonSearch',
    platforname: 'PDL-5 Results',
    classname: 'fab mr-1 fa-linkedin-square'
  }, {
    apiname: 'pdlPersonSearch',
    platforname: 'PDL-10 Results',
    classname: 'fab mr-1 fa-linkedin-square'
  }];
  bulkGrabbingDonePreviously: any;
  searchCalled: Boolean = false;
  showSearchResult: boolean = false;
  showPDLSearchResults: boolean = false;
  searchQuerySentToCSE: any = null
  searchResultNextPage: any = null
  totalSearchResultsCount: number = 0;
  pdlSearchResults: any[] = [];
  totalPDLSearchResultsCount: any;
  talentpoolAndCandidateData: any;
  isCategoryChanged: boolean;
  showLoading: boolean;
  totalClicked: number = 1;
  maxPageSize: number = 0;
  isNextPagePresent: boolean = true;
  booleanquery: any;
  booleanquery_to_display: any;
  refinementTags: any[] = [];
  @ViewChild('requestCredit') requestCredit: TemplateRef<any>;
  @ViewChild('historymodal') historymodal: TemplateRef<any>;

  starthistory: any = 0;
  searchToolboxHistory: any[] = [];
  technologyBucketList: any[] = [];
  fmcgBucketList: any[] = [];
  hrBucketList: any[] = [];
  salesBucketList: any[] = [];
  buckets: any[] = []
  bankingBucketList: any[] = []
  consultingBucketList: any[] = []
  insuranceBucketList: any[] = []

  showregion: string
  regionEvent: Subject<any> = new Subject();

  generateAIModal: boolean = false;

  subscriptions: Array<Subscription> = [];
  searchTab: string;
  constructor(private router: Router, private personSearchService: PersonSearchService, private _localstorageservice: LocalStorageService,private searchtoolbox: SearchtoolboxService, private modalService: NgbModal, private talentpoolservice: TalentpoolService,
    private sessionStorageService: SessionStorageService, private jdDataService: JdDataService, private personsearchservice: PersonSearchService,
    private continentHandlerService: ContinentHandlerService, private hashService: HashService, private route: ActivatedRoute,private location: Location, private transactionService: TransactionService, private aggsService: AggregationService
    ) {
      this._localstorageservice.setItem('region', null);

      this.location.subscribe((p) => {
        const tab = window.location.pathname;
        if(window.location.pathname === '/person/search') {
          this._localstorageservice.setItem('tabName', 'quicksearch');
          this.isQuickSearch = true;
          this.isAdvanceSearch = false;
          this.isSimilarCandidate = false;
          this.isJdSearch = false;
        } else if (tab == '/person/search/advance') {
          this._localstorageservice.setItem('tabName', 'advancedsearch');
          this.isQuickSearch = false;
          this.isAdvanceSearch = true;
          this.isSimilarCandidate = false;
          this.isJdSearch = false;
        } else if (tab == '/person/search/similar-candidate') {
          this._localstorageservice.setItem('tabName', 'similarcandidate');
          this.isQuickSearch = false;
          this.isAdvanceSearch = false;
          this.isSimilarCandidate = true;
          this.isJdSearch = false;
        } else if (tab == '/person/search/job-description') {
          this._localstorageservice.setItem('tabName', 'jdsearch');
          this.isQuickSearch = false;
          this.isAdvanceSearch = false;
          this.isSimilarCandidate = false;
          this.isJdSearch = true;
        }
      })
    }

  ngOnInit(): void {
      this.searchTab = this.router.url.split('/')[3];
    if(this.searchTab && this.searchTab == 'jd') {
      this._localstorageservice.setItem("tabName", 'jdsearch');
      this.sessionStorageService.setItem("historyRegion", null);
      this.isQuickSearch = false;
      this.isAdvanceSearch = false;
      this.isSimilarCandidate = false;
      this.isJdSearch = true;
    }
     const tabeName = this._localstorageservice.getItem('tabName');

    if(tabeName == 'quicksearch') {
      this.sessionStorageService.setItem("historyRegion", null);
      this.isQuickSearch = true;
      this.isAdvanceSearch = false;
      this.isSimilarCandidate = false;
      this.isJdSearch = false;
    } else if(tabeName == 'advancedsearch') {
      this.sessionStorageService.setItem("historyRegion", null);
      this.isQuickSearch = false;
      this.isAdvanceSearch = true;
      this.isSimilarCandidate = false;
      this.isJdSearch = false;
      this.router.navigate(['/person/search/advance'], {queryParams: {
        filter: this.route.snapshot.queryParams.filter
      }});
    } else if(tabeName == 'similarcandidate') {
      this.sessionStorageService.setItem("historyRegion", null);
      this.isQuickSearch = false;
      this.isAdvanceSearch = false;
      this.isSimilarCandidate = true;
      this.isJdSearch = false;
      this.router.navigate(['/person/search/similar-candidate']);
    } else if(tabeName == 'jdsearch') {
      this.sessionStorageService.setItem("historyRegion", null);
      this.isQuickSearch = false;
      this.isAdvanceSearch = false;
      this.isSimilarCandidate = false;
      this.isJdSearch = true;
      this.router.navigate(['/person/search/job-description']);
    }
    this.showregion = this._localstorageservice.getItem('region')

    // this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
    //   this.showregion = this._localstorageservice.getItem('region') ? this._localstorageservice.getItem('region') : response.continent ? response.continent.toLowerCase() : 'asia';
    //   this._localstorageservice.setItem('region', this.showregion);
    // });

    const continentUpdateSub = this.continentHandlerService.continentUpdateObservable.subscribe(continent => this.selectRegion(continent));
    this.subscriptions.push(continentUpdateSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  convertToK(number) {
    const suffixes = ['', 'K', 'M', 'B', 'T']; // Add more suffixes as needed for larger numbers
    for (const suffix of suffixes) {
      if (Math.abs(number) < 1000) {
        return number.toFixed(0) + suffix;
      }
      number /= 1000;
    }
    return number.toFixed(1) + 'T';
  }

  createReports() {
    let CharForCurrentCompany = []
    let CharForPastCompany = []
    let CharForCurrentJobtitle = []
    let charForPastJobTitle = []
    let ChartForGender = []
    let ChartForSkills = []
    let CharForworkCountry = []
    let CharForSeniority = []
    let CharForFunctions = []
    this.reportsAggs.company = this.reportsAggs.current_company ? this.reportsAggs.current_company : []
    this.reportsAggs.industry = this.reportsAggs.industry ? this.reportsAggs.industry : []
    this.reportsAggs.seniority = this.reportsAggs.seniority ? this.reportsAggs.seniority : []
    this.reportsAggs.pastcompany = this.reportsAggs.pastcompany ? this.reportsAggs.pastcompany : []
    this.reportsAggs.currentjobtitle = this.reportsAggs.jobtitle ? this.reportsAggs.jobtitle : []
    this.reportsAggs.pastjobtitle = this.reportsAggs.pastjobtitle ? this.reportsAggs.pastjobtitle : []
    this.reportsAggs.gender = this.reportsAggs.gender ? this.reportsAggs.gender : []
    this.reportsAggs.workcountry = this.reportsAggs.workcountry ? this.reportsAggs.workcountry : []
    this.reportsAggs.skills = this.reportsAggs.skills ? this.reportsAggs.skills : []
    let unknownGender = 0
    if (this.reportsAggs.gender.length > 1) {
      unknownGender = this.totalCandidatesCount - this.reportsAggs.gender[0].doc_count - this.reportsAggs.gender[1].doc_count
    } else if (this.reportsAggs.gender.length == 1) {
      unknownGender = this.totalCandidatesCount - this.reportsAggs.gender[0].doc_count
    } else if(!this.reportsAggs.gender.length) {
      unknownGender = this.totalCandidatesCount;
    }

    if(unknownGender) {
      this.reportsAggs.gender.push({
        key: "Not Known",
        doc_count: unknownGender,
      })
    }

    this.reportsAggs.workcountry.slice(0, 10).forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      CharForworkCountry.push(dataObj)
    })
    this.reportsAggs.gender.forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      ChartForGender.push(dataObj)
    })
    this.reportsAggs.industry.forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      CharForFunctions.push(dataObj)
    })
    this.reportsAggs.seniority.forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      CharForSeniority.push(dataObj)
    })
    this.reportsAggs.skills.slice(0, 10).forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      ChartForSkills.push(dataObj)
    })
    this.reportsAggs.company.slice(0, 10).forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      CharForCurrentCompany.push(dataObj)
    })
    this.reportsAggs.pastcompany.slice(0, 10).forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      CharForPastCompany.push(dataObj)
    })
    this.reportsAggs.currentjobtitle.slice(0, 10).forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      CharForCurrentJobtitle.push(dataObj)
    })
    this.reportsAggs.pastjobtitle.slice(0, 10).forEach(x => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)} <br> Professional count: ${x.doc_count}`
      }
      charForPastJobTitle.push(dataObj)
    })
    this.dataSourceCurrentCompany = {
      "type": "bar2d",
      "dataFormat": "json",
      "chart": {
        "xAxisPosition": "left",
        "paletteColors": "#cdbe31",
        "captionFontColor": "#575757",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "legendPosition": "right",
        "legendAllowDrag": "1",
        "theme": "fusion",
        showValues: '1',
        valuePosition: 'right',
      },
      "data": CharForCurrentCompany
    };

    this.dataSourceFunctions = {
      "type": "bar2d",
      "dataFormat": "json",
      "chart": {
        "xAxisPosition": "left",
        "paletteColors": "#cdbe31",
        "captionFontColor": "#575757",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "legendPosition": "right",
        "legendAllowDrag": "1",
        "theme": "fusion",
        showValues: '1',
        valuePosition: 'right',
      },
      "data": CharForFunctions
    };

    this.dataSourceWorkCountry = {
      "type": "bar2d",
      "dataFormat": "json",
      "chart": {
        "xAxisPosition": "left",
        "paletteColors": "#cdbe31",
        "captionFontColor": "#575757",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "legendPosition": "right",
        "legendAllowDrag": "1",
        "theme": "fusion",
        showValues: '1',
        valuePosition: 'right',
      },
      "data": CharForworkCountry
    }

    this.dataSourcePastCompany = {
      "type": "bar2d",
      "dataFormat": "json",
      "chart": {
        "xAxisPosition": "left",
        "paletteColors": "#cdbe31",
        "captionFontColor": "#575757",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "legendPosition": "right",
        "legendAllowDrag": "1",
        "theme": "fusion",
        showValues: '1',
        valuePosition: 'right',
      },
      "data": CharForPastCompany
    };

    this.dataSourceSkills = {
      "type": "bar2d",
      "dataFormat": "json",
      "chart": {
        "xAxisPosition": "left",
        "paletteColors": "#cdbe31",
        "captionFontColor": "#575757",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "legendPosition": "right",
        "legendAllowDrag": "1",
        "theme": "fusion",
        showValues: '1',
        valuePosition: 'right',
      },
      "data": ChartForSkills
    };

    this.dataSourceCurrentJobTitle = {
      "type": "bar2d",
      "dataFormat": "json",
      "chart": {
        "paletteColors": "#cdbe31",
        "captionFontColor": "#575757",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "legendPosition": "right",
        "legendAllowDrag": "1",
        "theme": "fusion",
        showValues: '1',
        valuePosition: 'right',
      },
      "data": CharForCurrentJobtitle
    };

    this.dataSourcePastJobTitle = {
      "type": "bar2d",
      "dataFormat": "json",
      "chart": {
        "paletteColors": "#cdbe31",
        "captionFontColor": "#575757",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "legendAllowDrag": "1",
        "theme": "fusion",
        showValues: '1',
        valuePosition: 'right',
        legendPosition: "bottom",
      },
      "data": charForPastJobTitle
    };

    this.dataSourceGender = {
      "type": "doughnut2d",
      "renderAt": "talent_gender",
      "dataFormat": "json",
      "chart": {
        "paletteColors": "#cdbe31, #665f18, #cdc57b, #332f0c, #cdc152, #cdc9a4, #998e25, #0a0902",
        "subCaption": "",
        "use3DLighting": "0",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "animateClockwise": "1",
        "legendAllowDrag": "0",
        "theme": "fusion",
        legendPosition: "bottom",
      },
      "data": ChartForGender
    }

    this.dataSourceSeniority = {
      "type": "doughnut2d",
      "renderAt": "talent_gender",
      "dataFormat": "json",
      "chart": {
        "paletteColors": "#cdbe31, #665f18, #cdc57b, #332f0c, #cdc152, #cdc9a4, #998e25, #0a0902",
        "subCaption": "",
        "use3DLighting": "0",
        "showPercentValues": "1",
        "decimals": "1",
        "yAxisNameFontColor": '#2C2C2C',
        "animateClockwise": "1",
        "legendAllowDrag": "0",
        "theme": "fusion",
        legendPosition: "bottom"
      },
      "data": CharForSeniority
    }
  }

  onTabChange(tab) {
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    switch (tab) {
      case 'quicksearch': {
        this._localstorageservice.setItem('tabName', 'quicksearch');
        this.isQuickSearch = true;
        this.isAdvanceSearch = false;
        this.isSimilarCandidate = false;
        this.isJdSearch = false;
        this.router.navigate(['/person/search']);
        break;
      }
      case 'advancedsearch': {
        this._localstorageservice.setItem('tabName', 'advancedsearch');
        this.isQuickSearch = false;
        this.isAdvanceSearch = true;
        this.isSimilarCandidate = false;
        this.isJdSearch = false;
        this.router.navigate(['/person/search/advance']);
        break;
      }
      case 'jdsearch': {
        this._localstorageservice.setItem('tabName', 'jdsearch');
        this.isQuickSearch = false;
        this.isAdvanceSearch = false;
        this.isSimilarCandidate = false;
        this.isJdSearch = true;
        this.router.navigate(['/person/search/job-description']);
        break;
      }
      case 'similarcandidate': {
        this._localstorageservice.setItem('tabName', 'similarcandidate');
        this.isQuickSearch = false;
        this.isAdvanceSearch = false;
        this.isSimilarCandidate = true;
        this.isJdSearch = false;
        this.router.navigate(['/person/search/similar-candidate']);
        break;
      }
    }
  }

  repeatSuggestion() {
    // To get related suggestions
    let value;
    let searchedParameter;
    if (this.jobtitles && this.jobtitles.length) {
      value = this.jobtitles[this.jobtitles.length - 1];
      searchedParameter = 'Job Title';
    } else if (this.preferredskills && this.preferredskills.length) {
      value = this.preferredskills[this.preferredskills.length - 1];
      searchedParameter = 'Skill';
    } else if (this.mandatoryskills && this.mandatoryskills.length) {
      value = this.mandatoryskills[this.mandatoryskills.length - 1];
      searchedParameter = 'Skill';
    }
    if (value) {
      this.getRelatedData(searchedParameter, value)
    }
  }

  getRelatedData(type: string, value: string, action?) {
    let data = {
      searchparameter: type,
      searchedstring: value.toString().trim().toLowerCase(),
      selectedjobtitlesarray: this.jobtitles.filter((x) => { return x != value }),
      selectedskillsarray: this.preferredskills.concat(this.mandatoryskills).filter((x) => { return x != value }),
      existingjobtitlessuggestionarray: this.recommendedjobtitle,
      existingskillssuggestionarray: this.recommendedskills,
      deselectedJobTitlesArray: this.deselectedJobTitlesArray,
      deselectedSkillsArray: this.deselectedSkillsArray
    }
    if (action == 'remove' && type == 'Job Title') {
      let selectedjob = data['selectedjobtitlesarray']
      data['searchedstring'] = selectedjob.length ? selectedjob[selectedjob.length - 1] : ''
      data['searchparameter'] = 'Job Title'
    } else if (action == 'remove' && type == 'Skill') {
      let selectedskill = data['selectedskillsarray']
      data['searchedstring'] = selectedskill.length ? selectedskill[selectedskill.length - 1] : ''
      data['searchparameter'] = 'Skill'
    }

    if (data.searchedstring.length) {
      this.searchtoolbox.recommendedData(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.recommendedjobtitle = res.data.related_job_titles
          this.recommendedskills = res.data.related_skills.filter((x) => x)
          this.filteredJobTitleOptions = []
          this.filteredPreferredSkillsOptions = []
          this.filteredMandatorySkillsOptions = []
          this.generateBooleanAndSearch('LinkedIn');
        }
      });
    }
  }

  generateBooleanAndSearch(value?) {
    this.getResultForLinkedin = []
    this.searchResults = []
    window.scrollTo(0, 0)
    this.platformselected = value
    if (this.jobtitles.length || this.mandatoryskills.length || this.preferredskills.length || this.locations.length || this.companies.length || this.excludekeywords.length) {
      this.fieldsRequired = false
      let data = {
        "startindex": this.startindex,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "currentjobtitle": this.isCurrentJobTitle ? true : false,
        "currentcompany": this.isCurrentCompany ? true : false,
        "opentowork": this.isOpentoWork ? true : false,
        "jobtitles": this.jobtitles,
        "preferredskills": this.preferredskills,
        "mandatoryskills": this.mandatoryskills,
        "locations": this.locations,
        "companies": this.companies.map(x => x.company_name),
        "synonyms": this.synonyms,
        "exclusionlist": this.excludekeywords,
        "calledviawebapp": true,
        "refinementtags": this.categorySelected && this.categorySelected != 'All' ? [this.categorySelected] : [],
        "industries": this.industries
      }


      if (this.platformselected == 'PDL-5 Results' || this.platformselected == 'PDL-10 Results') {
        data['minexperience'] = (this.minExperience >= 0) ? this.minExperience : null;
        data['maxexperience'] = (this.maxExperience >= 0) ? this.maxExperience : null;
        data['resultsize'] = (value == 'PDL-10 Results') ? 10 : 5;
        data['paginationkey'] = (this.pdlPaginationKey) ? this.pdlPaginationKey : null;
      }

      this.personSearchService.getBooleanQuery(data).subscribe((res: any) => {
          this.booleanquery = res.data.booleanquery
          this.booleanquery_to_display = res.data.booleanquery
          if (this.isOpentoWork) {
            this.booleanquery_to_display = this.booleanquery_to_display + 'AND'
          }

        // replace boolean word with symbol operator
        this.booleanquery_to_display = this.booleanquery_to_display.replace(/\|/g, 'OR')
        this.router.navigate(['/person/search/listing'], { queryParams: { keyword: this.booleanquery_to_display.trim(), type: 'jd-search' } });
      })
    } else {
      this.fieldsRequired = true
    }
  }

  receiveData($event){
    console.log($event)
  }

  redirectToListing(bucket) {
    // add two query params - one is keyword and other is source
    this.router.navigate(['/person/search/listing'], { queryParams: { keyword: bucket, source: 'bucket', bucketName: bucket } });
  }

  route2pricing() {
    this.modalService.dismissAll()
    if(this._localstorageservice.getItem('isteamMember')){
      this.modalService.open(this.requestCredit, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    }else{
      this.router.navigateByUrl('subscription/pricing')
    }
  }

  openHistoryModal() {
    this.modalService.open(this.historymodal, { windowClass: "myCustomModalClass", centered: true })
    this.gethistory()
  }

  gethistory(index?) {
    if (index) {
      this.starthistory = this.starthistory + 10
    } else {
      this.searchToolboxHistory = []
    }
    let data = {
      "startindex": this.starthistory,
      "usernumber": this._localstorageservice.getItem('usernumber')
    }
    this.searchtoolbox.fetchsearchtoolboxhistory(data).subscribe((res: any) => {
      if (res.status == 'success') {
        let response = res.data;
        this.searchToolboxHistory = this.searchToolboxHistory.concat(response.searchhistoryrecords)
      } else {
        console.log("Some error in loading history!");
      }
    })
  }

  getHistoryHeadline(history) {
    return history.jobtitles ? history.jobtitles : history.mandatoryskills ? history.mandatoryskills : history.preferredskills ? history.preferredskills : history.locations ? history.locations : history.booleanquery
  }


  formatDate(x) {
    let res = moment(x).format('Do MMM YY | hh:mm A')
    return res
  }

  marketJobs(){
    const jobboardModal = this.modalService.open(JobboardsComponent, { centered: true, size: 'lg'});
    // jobboardModal.componentInstance.jobNumber = this.jobnumber;
    // jobboardModal.componentInstance.biasState = true;
    // jobboardModal.componentInstance.minJobboard = 1;
    jobboardModal.componentInstance.noSkipAction = true;
    jobboardModal.result.then(() => {
      this.modalService.dismissAll();
      // this._localstorageservice.setItem('job_attract_modal:skip:' + this.jobnumber, "false")
      // this.success_message = 'Job will be posted on selected Job Board.';
      // setTimeout(() => this.success_message = '', 5000);
    }).catch(() => console.log('modal'));
  // } else {
  //   this.successDismiss();
  // }

  }

  redirectToTalentpool(){
    this.router.navigateByUrl("/talent/talentpool")
  }

  selectRegion(region) {
    this.showregion = region
   // this._localstorageservice.setItem('region', region)
    this.regionEvent.next(this.showregion)
  }

  changeContinent() {
    // Access flags don't vary by which region tab is being viewed, so this just needs the
    // already-loaded signal, not a fresh network call.
    const accessData = this.transactionService.access();
    if (accessData) {
      this._localstorageservice.setItem('hasEUPersonSearchAccess', accessData.haseupersonsearchaccess);
      this._localstorageservice.setItem('hasEUTalentInsightsAccess', accessData.haseutalentinsightsaccess)

      const currentRegion = this._localstorageservice.getItem('region');
      if(currentRegion == 'europe' && !accessData.haseupersonsearchaccess) {
        this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
          const region = response.continent ? response.continent.toLowerCase() : 'asia';
          this.showregion = region;
         // this._localstorageservice.setItem('region', region);
          this.aggsService.emitContinentEvent(this.showregion);
        });
      } else {
        this.aggsService.emitContinentEvent(this.showregion);
      }
    }
  }

}
